module.exports = __webpack_public_path__ + "static/media/tuesday.6ef2c7a6.ogg";